import apiClient from './client';
import type {
  Ingredient, IngredientCategory,
  PaginatedResponse, SingleResponse,
} from '@/types';

export interface IngredientListParams {
  page?:       number;
  limit?:      number;
  search?:     string;
  activeOnly?: boolean;
  categoryId?: string;
}

export const ingredientsApi = {
  list: (params: IngredientListParams = {}) =>
    apiClient.get<PaginatedResponse<Ingredient>>('/ingredients', { params }).then(r => r.data),

  get: (id: string) =>
    apiClient.get<SingleResponse<Ingredient>>(`/ingredients/${id}`).then(r => r.data.data),

  create: (data: Partial<Ingredient>) =>
    apiClient.post<SingleResponse<Ingredient>>('/ingredients', data).then(r => r.data.data),

  update: (id: string, data: Partial<Ingredient>) =>
    apiClient.put<SingleResponse<Ingredient>>(`/ingredients/${id}`, data).then(r => r.data.data),

  delete: (id: string) =>
    apiClient.delete(`/ingredients/${id}`).then(r => r.data),

  dropdown: () =>
    apiClient.get<SingleResponse<Pick<Ingredient, 'id' | 'name' | 'category_name'>[]>>('/ingredients/dropdown').then(r => r.data.data),

  // Categories
  listCategories: () =>
    apiClient.get<SingleResponse<IngredientCategory[]>>('/ingredients/categories').then(r => r.data.data),

  createCategory: (name: string) =>
    apiClient.post<SingleResponse<IngredientCategory>>('/ingredients/categories', { name }).then(r => r.data.data),

  updateCategory: (id: string, name: string) =>
    apiClient.put<SingleResponse<IngredientCategory>>(`/ingredients/categories/${id}`, { name }).then(r => r.data.data),

  deleteCategory: (id: string) =>
    apiClient.delete(`/ingredients/categories/${id}`).then(r => r.data),
};
